// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__ZS4kB","requiredAsterisk":"Info_requiredAsterisk__3gUFe"};